import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-i-small', 'LetterISmall', [["path",{"d":"M12 8v8"}]]);